export const addInventoryUseCase = async (inventoryApi,info) => {
    try {
      const response =  await inventoryApi.addInventoryApi(info);
      const actualInfoEntered = info;
      return {...response,actualInfoEntered};
    } catch (error) {
      throw new Error(error.message);
    }
};